import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';
import { TieredMenuModule } from 'primeng/tieredmenu';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { SortableColumnModule, SwitcherModule } from '@tablesready/common-ui';
import { FrontendModalModule } from '@tablesready/frontend-modal';

import { TrTableComponent } from './tr-table.component';
import { TrCellDirective } from './tr-cell.directive';
import { TrHeaderCellDirective } from './tr-header-cell.directive';
import { TrGroupHeaderDirective } from './tr-group-header.directive';
import { ColumnVisibilityModalComponent } from '../column-visibility-modal/column-visibility-modal.component';
import { TrListComponent } from '../tr-list/tr-list.component';

@NgModule({
  declarations: [
    TrTableComponent,
    TrListComponent,
    TrCellDirective,
    TrHeaderCellDirective,
    TrGroupHeaderDirective,
    ColumnVisibilityModalComponent,
  ],
  exports: [
    TrTableComponent,
    // Exported as well as declared: the shell renders it for narrow viewports, but
    // a page that is a list by nature can use it directly.
    TrListComponent,
    TrCellDirective,
    TrHeaderCellDirective,
    TrGroupHeaderDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    TieredMenuModule,
    SortableColumnModule,
    SwitcherModule,
    NgbTooltipModule,
    FrontendModalModule,
  ],
})
export class TrTableModule {}
